module.exports = __webpack_public_path__ + "img/2.6a1e5f84.jpg";